/**
 * Утилиты для работы с токенами и аутентификацией
 * Stage 7: Secure Storage (Capacitor Preferences / localStorage)
 */
import { SecureStorage } from './secure-storage';

export const ACCESS_TOKEN_KEY = 'accessToken';
export const REFRESH_TOKEN_KEY = 'refreshToken';
export const USER_DATA_KEY = 'userData';

/**
 * Функция для установки токенов авторизации
 */
export const setTokens = async (accessToken: string, refreshToken: string): Promise<void> => {
  await SecureStorage.set(ACCESS_TOKEN_KEY, accessToken);
  await SecureStorage.set(REFRESH_TOKEN_KEY, refreshToken);
};

/**
 * Функция для получения access токена
 */
export const getAccessToken = async (): Promise<string | null> => {
  return SecureStorage.get(ACCESS_TOKEN_KEY);
};

/**
 * Функция для получения refresh токена
 */
export const getRefreshToken = async (): Promise<string | null> => {
  return SecureStorage.get(REFRESH_TOKEN_KEY);
};

/**
 * Функция для сохранения данных пользователя (localStorage для UI данных)
 */
export const setUserData = (userData: unknown): void => {
  localStorage.setItem(USER_DATA_KEY, JSON.stringify(userData));
};

/**
 * Функция для получения данных пользователя
 */
export const getUserData = (): unknown | null => {
  const userData = localStorage.getItem(USER_DATA_KEY);
  return userData ? JSON.parse(userData) : null;
};

/**
 * Функция для очистки данных авторизации
 */
export const clearAuthData = async (): Promise<void> => {
  await SecureStorage.remove(ACCESS_TOKEN_KEY);
  await SecureStorage.remove(REFRESH_TOKEN_KEY);
  localStorage.removeItem(USER_DATA_KEY);
};

/**
 * Функция для проверки авторизации
 */
export const isAuthenticated = async (): Promise<boolean> => {
  const token = await getAccessToken();
  return !!token;
};

/**
 * Функция для выхода из системы
 */
export const logout = async (): Promise<void> => {
  await clearAuthData();
  window.location.href = '/login';
};

/**
 * Функция для получения заголовка с токеном авторизации
 */
export const getAuthHeader = async (): Promise<{ Authorization: string } | Record<string, never>> => {
  const token = await getAccessToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};
